import React from 'react';
import BuildingSelectComponent from '../../components/Filters/buildingSelect';
import { DOES_NOT_EXIST, NOT_COMPATIBLE_SCHEDULES } from '../../helpers/constants';

class BuildingSelect extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            building: '',
            buildingData: []
        }
        this.handleChangeBuilding = this.handleChangeBuilding.bind(this);
    }

    componentDidMount(){
        this.setInitialState();
        this.setState({
            building:'',
        });
    }

    componentDidUpdate(prevProps) {
        if ((prevProps.data !== this.props.data) || (prevProps.filters !== this.props.filters)) {
            this.setInitialState();
            this.setState({
                building:'',
            });
        }
    }

    resetFilterMessage(){
        const { id, name, updateFiltersMessage } = this.props;
        const message = {
            id: id,
            name: name,
            parameters: ''
        }
        updateFiltersMessage(message);
    }

    setInitialState() {
        const { data } = this.props;
        var buildingData = [];
        for (var i = 0; i < data.length; i++) {
            var dataItem = {
                name: data[i].name,
                id: data[i].id,
                serverDisabled: false,
                errroMessage: ""
            }
            
            //parse extra data
            if(data[i].subExtraDataList !== undefined && data[i].subExtraDataList.length > 0){ //check if subExtraDataList exists
                for (var item of data[i].subExtraDataList) {
                    switch (parseInt(item.id)) {
                        case DOES_NOT_EXIST:
                            dataItem.serverDisabled = true;
                            dataItem.errroMessage = item.name;
                        break;
                        case NOT_COMPATIBLE_SCHEDULES:
                            dataItem.serverDisabled = true;
                            dataItem.errroMessage = item.name;
                        break;
                    }
                }
            }
            
            buildingData.push(dataItem);
        }
        this.resetFilterMessage();

        this.setState({ 
            buildingData: buildingData
        });
    }

    notifyParentFilter(buildingId, buildingName){
        const { id, handleChangeSpaceSelect } = this.props;
        if(handleChangeSpaceSelect !== undefined){
            var buildingData = {
                id: buildingId,
                name: buildingName
            };
            if(buildingId !== -1){   
                var data = {
                    building: buildingData,
                    filterId: id
                }
                handleChangeSpaceSelect(data);
            }
        }
    }

    /**
     * Función que asigna edificio seleccionado y actualiza mensaje de filtros.
     * @param {Event} e - Evento que se desencadena al hacer clic sobre un edificio.
    */
    handleChangeBuilding(e) {
        const { id, name, updateFiltersMessage } = this.props;
        const { buildingData } = this.state;
        const buildingName = e.target.value;
        var parametersArray = [];
        var parameters = '';
        var buildingId;
        var found = false;
        buildingData.map(dataItem => {
            if ((dataItem.name === buildingName) && (dataItem.serverDisabled === false)){
                buildingId = dataItem.id;
                found = true;
            }
        });
        if(found === false){
            return;
        }

        this.setState({ 
            building: buildingName
        });
        parametersArray.push(
            '<parameter>',
            '<id>',
            buildingId,
            '</id>',
            '<name>',
            buildingName,
            '</name>',
            '</parameter>'
        );
        parameters = parametersArray.join('');
        const message = {
            id: id,
            name: name,
            parameters: parameters
        }
        updateFiltersMessage(message);
        this.notifyParentFilter(buildingId, buildingName);
    };

    render() {
        const { building, buildingData } = this.state;
        const { required } = this.props;
        return (
            <BuildingSelectComponent
                building={building}
                data={buildingData}
                required={required}
                handleChangeBuilding={this.handleChangeBuilding}
            />
        )
    }
}

export default BuildingSelect;